// import { useCallback, useReducer } from 'react';

// const initialState = {
//   isLoading: false,
//   data: null,
//   isFailed: false,
//   isSuccess: false
// };

// const reducer = (state, action) => {
//   switch (action.type) {
//     case 'INIT':
//       return {
//         ...initialState,
//         isLoading: true
//       };
//     case 'SUCCESS':
//       return {
//         ...initialState,
//         data: action.payload,
//         isSuccess: true
//       };
//     case 'FAILURE':
//       return {
//         ...initialState,
//         isFailed: true
//       };
//     case 'SET_STATE':
//       return {
//         ...state,
//         data: action.payload
//       };
//     default:
//       state;
//   }
// };

// const useAsync = () => {
//   const [state, dispatch] = useReducer(reducer, initialState);

//   const setState = useCallback(
//     (data) => {
//       dispatch({ type: 'SET_STATE', payload: data });
//     },
//     [dispatch]
//   );

//   const run = (method, path, headers, request, callback) => {
//     dispatch({ type: 'INIT' });
//     method(path, headers, request)
//       .then((res) => {
//         dispatch({ type: 'SUCCESS', payload: [] });
//         callback(res, null);
//       })
//       .catch((error) => {
//         dispatch({ type: 'FAILURE' });
//         callback(null, error);
//       });
//   };
//   return {
//     run,
//     state,
//     setState
//   };
// };

// export default useAsync;

import * as React from 'react';
const API_STATES = {
  is_loading: 'isLoading',
  is_success: 'isSuccessful',
  is_failed: 'isFailure'
};
type InitialStateTypes = {
  isLoading: boolean;
  isSuccess: boolean;
  isFailed: boolean;
  data: object;
  error: object;
};

const initialState: InitialStateTypes = {
  isLoading: false,
  isSuccess: false,
  isFailed: false,
  data: null,
  error: null
};

const reducer = (state, action) => {
  switch (action.type) {
    case API_STATES.is_loading:
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        isFailed: false
      };
    case API_STATES.is_success:
      return {
        ...state,
        data: action.data,
        isLoading: false,
        isSuccess: true,
        isFailed: false,
        error: ''
      };
    case API_STATES.is_failed:
      return {
        ...state,
        data: null,
        isLoading: false,
        isSuccess: false,
        isFailed: true,
        error: action.error
      };
    case 'SET_DATA':
      return {
        ...state,
        data: action.data
      };
    case 'RESET_DATA':
      return initialState;
    default:
      return state;
  }
};
const useAsync = (successCallback, errorCallback) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const run = (method: any, ...config) => {
    {
      dispatch({ type: API_STATES.is_loading });
      method(...config)
        .then((res) => {
          if (successCallback) {
            const result = successCallback(res);
            dispatch({ type: API_STATES.is_success, data: result });
          } else if (res?.data) {
            dispatch({ type: API_STATES.is_success, data: res.data });
          } else {
            dispatch({ type: API_STATES.is_success, data: res });
          }
        })
        .catch((err) => {
          if (errorCallback) {
            errorCallback(err);
          }
          dispatch({ type: API_STATES.is_failed, error: err });
        });
    }
  };

  const setData = React.useCallback(
    (data) => dispatch({ type: 'SET_DATA', data }),
    [dispatch]
  );
  const resetData = React.useCallback(
    () => dispatch({ type: 'RESET_DATA' }),
    [dispatch]
  );

  return {
    run,
    state,
    setData,
    resetData
  };
};

export default useAsync;
